export function initBackgroundParticles() {
  const particleCount = 30;
  const container = document.body;

  // Clear existing particles
  const existingParticles = document.querySelectorAll('.particle');
  existingParticles.forEach(particle => particle.remove());

  for (let i = 0; i < particleCount; i++) {
    const particle = document.createElement('div');
    particle.className = 'particle';
    
    // Random size between 3px and 8px
    const size = Math.random() * 5 + 3;
    particle.style.width = `${size}px`;
    particle.style.height = `${size}px`;
    
    // Random position
    particle.style.left = `${Math.random() * 100}%`;
    particle.style.top = `${Math.random() * 100}%`;
    
    // Random animation delay
    particle.style.animationDelay = `${Math.random() * 8}s`;
    
    // Random color from theme
    const colors = ['rgba(92, 225, 230, 0.2)', 'rgba(214, 177, 255, 0.2)', 'rgba(165, 255, 214, 0.2)'];
    particle.style.background = colors[Math.floor(Math.random() * colors.length)];
    
    container.appendChild(particle);
  }
} 